module.exports = __webpack_public_path__ + "static/media/filter_icon.1f47b1e4.svg";